import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
  retrieve_company_representatives_role_list: { status: "idle" },
};

export const retrieve_company_representatives_role_list_Slice = createSlice({
  name: "retrieve_company_representatives_role_list",
  initialState,
  reducers: {
    success_retrieve_company_representatives_role_list: (state, action) => {
      state.retrieve_company_representatives_role_list = { status: app_consts.SUCCESS, data: action.payload };
    },
    fail_retrieve_company_representatives_role_list: (state, action) => {
      state.retrieve_company_representatives_role_list = { status: app_consts.FAIL, message: action.payload };
    },
    reset_retrieve_company_representatives_role_list: (state) => {
      state.retrieve_company_representatives_role_list = { status: app_consts.IDLE };
    },
    loading_retrieve_company_representatives_role_list: (state) => {
      state.retrieve_company_representatives_role_list = { status: app_consts.LOADING };
    },
  },
});

export const {
  success_retrieve_company_representatives_role_list,
  fail_retrieve_company_representatives_role_list,
  reset_retrieve_company_representatives_role_list,
  loading_retrieve_company_representatives_role_list,
} = retrieve_company_representatives_role_list_Slice.actions;

export default retrieve_company_representatives_role_list_Slice.reducer;
